import axios from 'axios'

// Trạng thái mặc định
const defaultState = {
  notifications: {
    email_enabled: false,
    smtp_host: 'smtp.gmail.com',
    smtp_port: 587,
    smtp_user: 'your-email@gmail.com',
    smtp_pass: null,
    telegram_enabled: false,
    telegram_token: null,
    telegram_chat_id: null
  },
  devices: {
    auto_restart: true,
    offline_threshold: 300,
    retry_attempts: 3,
    auto_update: false
  },
  backup: {
    auto_backup: true,
    frequency: 'daily',
    retention_days: 30,
    last_backup: null
  },
  system: {
    session_timeout: 30,
    max_upload_size: 5242880,
    maintenance_mode: false,
    debug_mode: false
  }
}

// State
const state = {
  ...JSON.parse(JSON.stringify(defaultState)) // Deep clone
}

// Getters
const getters = {
  isMaintenanceMode: state => state.system.maintenance_mode,
  isDebugMode: state => state.system.debug_mode,
  sessionTimeout: state => state.system.session_timeout,
  notificationSettings: state => state.notifications,
  deviceSettings: state => state.devices,
  backupSettings: state => state.backup
}

// Mutations
const mutations = {
  SET_SETTINGS(state, settings) {
    Object.assign(state, settings)
  },
  UPDATE_NOTIFICATION_SETTINGS(state, settings) {
    state.notifications = { ...state.notifications, ...settings }
  },
  UPDATE_DEVICE_SETTINGS(state, settings) {
    state.devices = { ...state.devices, ...settings }
  },
  UPDATE_BACKUP_SETTINGS(state, settings) {
    state.backup = { ...state.backup, ...settings }
  },
  UPDATE_SYSTEM_SETTINGS(state, settings) {
    state.system = { ...state.system, ...settings }
  },
  RESET(state) {
    Object.assign(state, JSON.parse(JSON.stringify(defaultState)))
  }
}

// Actions
const actions = {
  async fetchSettings({ commit }) {
    const response = await axios.get('/settings')
    commit('SET_SETTINGS', response.data)
    return response.data
  },

  async updateSettings({ commit }, settings) {
    const response = await axios.put('/settings', settings)
    commit('SET_SETTINGS', response.data)
    return response.data
  },

  async updateNotificationSettings({ commit }, settings) {
    const response = await axios.put('/settings/notifications', settings)
    commit('UPDATE_NOTIFICATION_SETTINGS', response.data)
    return response.data
  },

  async updateDeviceSettings({ commit }, settings) {
    const response = await axios.put('/settings/devices', settings)
    commit('UPDATE_DEVICE_SETTINGS', response.data)
    return response.data
  },

  async updateBackupSettings({ commit }, settings) {
    const response = await axios.put('/settings/backup', settings)
    commit('UPDATE_BACKUP_SETTINGS', response.data)
    return response.data
  },

  async updateSystemSettings({ commit }, settings) {
    const response = await axios.put('/settings/system', settings)
    commit('UPDATE_SYSTEM_SETTINGS', response.data)
    return response.data
  },

  async backupNow() {
    const response = await axios.post('/settings/backup/now')
    return response.data
  },

  async restoreBackup(_, { id }) {
    const response = await axios.post(`/settings/backup/restore/${id}`)
    return response.data
  },

  async testEmailSettings(_, settings) {
    const response = await axios.post('/settings/notifications/test-email', settings)
    return response.data
  },

  async testTelegramSettings(_, settings) {
    const response = await axios.post('/settings/notifications/test-telegram', settings)
    return response.data
  },

  resetSettings({ commit }) {
    commit('RESET')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}